import styled from "styled-components";

export const Styles = styled.div`
  .organogram-page {
    .organogram-section {
      padding: 80px 0;
      background: #f8f9fa;
      min-height: 100vh;
      
      @media (max-width: 768px) {
        padding: 40px 0;
      }
    }

    .organogram-content {
      background: #ffffff;
      border-radius: 15px;
      padding: 40px 20px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      max-width: 1200px;
      margin: 0 auto;

      @media (max-width: 768px) {
        padding: 30px 15px;
        margin: 0 10px;
      }
    }

    .organogram-header {
      text-align: center;
      margin-bottom: 40px;

      .organogram-title {
        font-size: 2.5rem;
        font-weight: 700;
        color: #2c3e50;
        margin-bottom: 10px;

        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }

      .organogram-subtitle {
        font-size: 1.1rem;
        color: #666;
        margin: 0;
      }
    }

    .org-chart {
      max-width: 1000px;
      margin: 0 auto;
      position: relative;
    }

    /* Teal Header */
    .org-header-yellow {
      background: #4A9B9B;
      border-radius: 25px;
      padding: 15px 30px;
      text-align: center;
      margin-bottom: 30px;
      
      h1 {
        font-size: 1.8rem;
        font-weight: 700;
        color: white;
        margin: 0;
        
        @media (max-width: 768px) {
          font-size: 1.5rem;
        }
      }
    }

    /* Support Cell Box */
    .support-cell-box {
      background: #31859C;
      color: white;
      border-radius: 15px;
      padding: 20px;
      text-align: center;
      max-width: 500px;
      margin: 0 auto;
      box-shadow: 0 8px 25px rgba(74, 155, 155, 0.3);
      
      .support-cell-header {
        background: rgba(255, 255, 255, 0.2);
        padding: 8px 15px;
        border-radius: 8px;
        font-size: 0.9rem;
        font-weight: 600;
        margin-bottom: 15px;
      }
      
      .chair-section {
        .chair-label {
          background: rgba(255, 255, 255, 0.9);
          color: #4A9B9B;
          padding: 8px 20px;
          border-radius: 20px;
          font-size: 1rem;
          font-weight: 700;
          margin-bottom: 15px;
          display: inline-block;
        }
        
        .chair-info {
          .chair-name {
            font-size: 1.3rem;
            font-weight: 700;
            margin-bottom: 5px;
          }
          
          .chair-title {
            font-size: 1rem;
            opacity: 0.9;
          }
        }
      }
    }

    /* Connection from Chair to Level 2 */
     .chair-to-level2 {
        position: relative;
        height: 80px;
        margin: 20px 0;
        
        .vertical-line-main {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 3px;
          height: 40px;
          background: #4A9B9B;
        }
        
        .horizontal-split {
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          width: 300px;
          height: 3px;
          background: #4A9B9B;
          
          @media (max-width: 768px) {
            display: none;
          }
        }
        
        .split-verticals {
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          width: 300px;
          display: flex;
          justify-content: space-between;
          
          @media (max-width: 768px) {
            display: none;
          }
          
          .left-vertical,
          .right-vertical {
            width: 3px;
            height: 40px;
            background: #4A9B9B;
          }
        }
        
        @media (max-width: 768px) {
          height: 40px;
          margin: 15px 0;
        }
      }

     /* Level 2 Container */
     .level-2-container {
       display: flex;
       justify-content: center;
       gap: 80px;
       margin: 30px 0;
       
       @media (max-width: 768px) {
         flex-direction: column;
         gap: 20px;
         align-items: center;
       }
     }

     /* Co-Chair Box */
     .co-chair-box {
       background: #6c757d;
       color: white;
       border-radius: 15px;
       padding: 20px;
       text-align: center;
       min-width: 200px;
       box-shadow: 0 8px 25px rgba(108, 117, 125, 0.3);
       
       .role-header {
         font-size: 0.9rem;
         font-weight: 700;
         margin-bottom: 10px;
         background: rgba(255, 255, 255, 0.2);
         padding: 5px 10px;
         border-radius: 10px;
       }
       
       .person-name {
         font-size: 1.1rem;
         font-weight: 600;
         margin-bottom: 5px;
       }
       
       .person-dept {
         font-size: 0.9rem;
         opacity: 0.9;
       }
     }

     /* COO Box */
     .coo-box {
       background: #20C997;
       color: white;
       border-radius: 15px;
       padding: 20px;
       text-align: center;
       min-width: 250px;
       box-shadow: 0 8px 25px rgba(32, 201, 151, 0.3);
       
       .role-header {
         font-size: 0.85rem;
         font-weight: 700;
         margin-bottom: 10px;
         background: rgba(255, 255, 255, 0.2);
         padding: 5px 10px;
         border-radius: 10px;
       }
       
       .person-name {
         font-size: 1.1rem;
         font-weight: 600;
       }
     }

     /* Connection from COO to Experts */
     .coo-to-experts {
        position: relative;
        height: 80px;
        margin: 30px 0;
        
        .coo-vertical {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(75px);
          width: 3px;
          height: 40px;
          background: #4A9B9B;
          
          @media (max-width: 768px) {
            transform: translateX(-50%);
          }
        }
        
        .experts-horizontal {
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          width: 80%;
          height: 3px;
          background: #4A9B9B;
          max-width: 700px;
          
          @media (max-width: 768px) {
            display: none;
          }
        }
        
        .expert-verticals {
          position: absolute;
          top: 40px;
          left: 50%;
          transform: translateX(-50%);
          width: 80%;
          max-width: 700px;
          display: flex;
          justify-content: space-between;
          
          @media (max-width: 768px) {
            display: none;
          }
          
          .expert-drop {
            width: 3px;
            height: 40px;
            background: #4A9B9B;
            
            @media (max-width: 768px) {
              height: 20px;
            }
          }
        }
        
        @media (max-width: 768px) {
          height: 40px;
          margin: 20px 0;
        }
      }

    /* Expert Grid */
    .expert-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 15px;
      margin-top: 20px;
      
      @media (max-width: 992px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
      }
      
      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
      }
      
      @media (max-width: 480px) {
        grid-template-columns: 1fr;
      }
    }

    /* Expert Boxes */
    .expert-box {
      background: #f8f9fa;
      border: 2px solid #dee2e6;
      border-radius: 10px;
      padding: 15px 10px;
      text-align: center;
      min-height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      &:hover {
        border-color: #4A9B9B;
        background: #ffffff;
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(74, 155, 155, 0.2);
      }
      
      .expert-text {
        font-size: 0.85rem;
        font-weight: 600;
        color: #495057;
        line-height: 1.3;
        
        @media (max-width: 768px) {
          font-size: 0.8rem;
        }
      }
    }

    /* Remove the old info section */
    .org-info {
      display: none;
    }

    /* Responsive adjustments */
    @media (max-width: 768px) {
      .org-chart {
        padding: 0 10px;
      }
      
      .level-2-container {
        .co-chair-box,
        .coo-box {
          min-width: auto;
          width: 100%;
          max-width: 280px;
        }
      }
    }
  }
`;